/**
 * @fileoverview Agent definition for world-event-snapshotter-v3.
 *
 * This agent analyzes a chapter and updates a world event's state,
 * creating a snapshot that reflects any changes from the chapter events.
 *
 * @category world-building.events.snapshots
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-event-snapshotter-v3',
  kind: 'primitive',
  name: 'World Event Snapshotter',
  description: 'Updates a world event state after a chapter, creating a point-in-time snapshot.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.events.snapshots',
    usedBy: ['use-world-event-snapshotter-v3.ts'],
    usedInComposites: [],
    relatedAgents: ['world-event-details-generator-v3'],
  },
};
